import { render, staticRenderFns } from "./UserLeft.vue?vue&type=template&id=7e7270b6&scoped=true"
import script from "./UserLeft.vue?vue&type=script&lang=js"
export * from "./UserLeft.vue?vue&type=script&lang=js"
import style0 from "./UserLeft.vue?vue&type=style&index=0&id=7e7270b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7270b6",
  null
  
)

export default component.exports